(function () {
  'use strict';
  if (window.__PilacomCompare) return;

  var MAX = 3;
  var LS  = 'pilacom_cmp';

  var items  = [];
  var fields = [];

  /* ── Boot ─────────────────────────────────────────────────────────────── */

  function boot() {
    readConfig();
    readStorage();
    injectStyles();
    injectDOM();
    bindStatic();
    scanToggles();
    refresh();
    new MutationObserver(scanToggles).observe(document.body, { childList: true, subtree: true });
    window.__PilacomCompare = { add: add, remove: del, clear: clearAll, open: openModal };
  }

  function readConfig() {
    var el = document.querySelector('[id^="pcg-cmp-cfg"]');
    if (!el) return;
    try { fields = JSON.parse(el.textContent).fields || []; } catch (_) {}
  }

  function readStorage() {
    try { items = JSON.parse(localStorage.getItem(LS)) || []; }
    catch (_) { items = []; }
    if (!Array.isArray(items)) items = [];
  }

  function save() {
    try { localStorage.setItem(LS, JSON.stringify(items)); } catch (_) {}
  }

  /* ── Toggle wiring ────────────────────────────────────────────────────── */

  function scanToggles() {
    document.querySelectorAll('.pcg-cmp-toggle:not([data-cmp-wired])').forEach(function (btn) {
      btn.dataset.cmpWired = '1';
      btn.addEventListener('click', onToggle);
    });
  }

  function onToggle() {
    var id = this.dataset.cmpId;
    if (!id) return;
    if (has(id)) {
      del(id);
    } else {
      if (items.length >= MAX) return;
      var data = readItemData(this.dataset.cmpBlock);
      if (data) add(data);
    }
  }

  function readItemData(blockId) {
    var el = blockId && document.getElementById('pcg-cmp-d-' + blockId);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  /* ── State ────────────────────────────────────────────────────────────── */

  function has(id) { return items.some(function (x) { return x.id == id; }); }

  function add(data) {
    if (has(data.id) || items.length >= MAX) return;
    items.push(data);
    save();
    refresh();
  }

  function del(id) {
    items = items.filter(function (x) { return x.id != id; });
    save();
    var modal = document.getElementById('pcg-cmp-modal');
    if (modal && !modal.hidden) {
      if (items.length < 2) { closeModal(); } else { renderTable(); }
    }
    refresh();
  }

  function clearAll() {
    items = [];
    save();
    closeModal();
    refresh();
  }

  /* ── Refresh ──────────────────────────────────────────────────────────── */

  function refresh() {
    refreshToggles();
    refreshDrawer();
    refreshBar();
  }

  function refreshToggles() {
    document.querySelectorAll('.pcg-cmp-toggle').forEach(function (btn) {
      var id  = btn.dataset.cmpId;
      var on  = has(id);
      var max = !on && items.length >= MAX;
      btn.setAttribute('aria-pressed', String(on));
      btn.classList.toggle('is-on',    on);
      btn.disabled = max;
      btn.classList.toggle('is-maxed', max);
    });
  }

  function refreshDrawer() {
    var drawer = document.getElementById('pcg-cmp-drawer');
    var list   = document.getElementById('pcg-cmp-dl');
    var goBtn  = document.getElementById('pcg-cmp-go');
    if (!drawer) return;
    var n = items.length;
    drawer.classList.toggle('is-open', n > 0);
    list.innerHTML = items.map(function (it) {
      return '<li class="pcg-cmp-di">' +
        '<div class="pcg-cmp-dth">' + (it.image ? '<img src="' + h(it.image) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="pcg-cmp-din"><span class="pcg-cmp-dn">' + h(it.title) + '</span><span class="pcg-cmp-dp">' + h(it.price) + '</span></div>' +
        '<button class="pcg-cmp-dx" data-rid="' + h(it.id) + '" aria-label="Retirer">×</button>' +
      '</li>';
    }).join('');
    list.querySelectorAll('.pcg-cmp-dx').forEach(function (b) {
      b.addEventListener('click', function () { del(b.dataset.rid); });
    });
    goBtn.disabled = n < 2;
  }

  function refreshBar() {
    var bar    = document.getElementById('pcg-cmp-bar');
    var label  = document.getElementById('pcg-cmp-bl');
    var goBtn  = document.getElementById('pcg-cmp-bgo');
    if (!bar) return;
    var n = items.length;
    bar.classList.toggle('is-open', n > 0);
    if (label) label.textContent = n + ' produit' + (n > 1 ? 's' : '') + ' sélectionné' + (n > 1 ? 's' : '');
    if (goBtn) goBtn.disabled = n < 2;
  }

  /* ── Modal ────────────────────────────────────────────────────────────── */

  function openModal() {
    if (items.length < 2) return;
    var modal = document.getElementById('pcg-cmp-modal');
    if (!modal) return;
    renderTable();
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var cl = document.getElementById('pcg-cmp-mc');
      if (cl) cl.focus();
    }, 60);
  }

  function closeModal() {
    var modal = document.getElementById('pcg-cmp-modal');
    if (modal) modal.hidden = true;
    document.body.style.overflow = '';
  }

  function renderTable() {
    var body = document.getElementById('pcg-cmp-mb');
    if (!body) return;

    var heads = items.map(function (it) {
      return '<th class="pcg-ct-ph" scope="col">' +
        (it.image
          ? '<img src="' + h(it.image) + '" class="pcg-ct-pi" alt="">'
          : '<div class="pcg-ct-pi pcg-ct-pi--empty"></div>') +
        '<p class="pcg-ct-pn">' + h(it.title) + '</p>' +
        '<p class="pcg-ct-pp">' + h(it.price) + '</p>' +
        '<button class="pcg-ct-pr" data-rid="' + h(it.id) + '">Retirer</button>' +
      '</th>';
    }).join('');

    var rows = fields.map(function (f, fi) {
      var cells = items.map(function (it) {
        var raw = it.meta && it.meta[fi] != null ? it.meta[fi] : null;
        var val = raw === true ? 'Oui'
          : raw === false ? 'Non'
          : (raw !== null && raw !== '' ? strip(String(raw)) : '—');
        return '<td class="pcg-ct-val">' + h(val) + '</td>';
      }).join('');
      return '<tr><th class="pcg-ct-lbl" scope="row">' + h(f.label) + '</th>' + cells + '</tr>';
    }).join('');

    var footer = items.map(function (it) {
      return '<td class="pcg-ct-foot">' +
        (it.url ? '<a href="' + h(it.url) + '" class="pcg-ct-link">Voir le produit</a>' : '') +
      '</td>';
    }).join('');

    body.innerHTML =
      '<div class="pcg-ct-wrap"><table class="pcg-ct">' +
        '<thead><tr><th class="pcg-ct-corner" scope="col"></th>' + heads + '</tr></thead>' +
        '<tbody>' + rows + '</tbody>' +
        '<tfoot><tr><td class="pcg-ct-corner"></td>' + footer + '</tr></tfoot>' +
      '</table></div>';

    body.querySelectorAll('.pcg-ct-pr').forEach(function (b) {
      b.addEventListener('click', function () { del(b.dataset.rid); });
    });
  }

  /* ── DOM injection ────────────────────────────────────────────────────── */

  function injectDOM() {
    if (document.getElementById('pcg-cmp-root')) return;
    var root = document.createElement('div');
    root.id = 'pcg-cmp-root';
    root.innerHTML =
      /* Desktop drawer */
      '<aside class="pcg-cmp-drawer" id="pcg-cmp-drawer" aria-label="Produits à comparer">' +
        '<div class="pcg-cmp-dh"><b class="pcg-cmp-dt">Comparer</b>' +
        '<button class="pcg-cmp-dcl" id="pcg-cmp-dcl">Tout effacer</button></div>' +
        '<ul class="pcg-cmp-dl" id="pcg-cmp-dl"></ul>' +
        '<p class="pcg-cmp-dmax">Max ' + MAX + ' produits</p>' +
        '<button class="pcg-cmp-go" id="pcg-cmp-go" disabled>Comparer maintenant</button>' +
      '</aside>' +

      /* Mobile bar */
      '<div class="pcg-cmp-bar" id="pcg-cmp-bar">' +
        '<div class="pcg-cmp-bi">' +
          '<span class="pcg-cmp-bl" id="pcg-cmp-bl"></span>' +
          '<div class="pcg-cmp-ba">' +
            '<button class="pcg-cmp-bcl" id="pcg-cmp-bcl">Effacer</button>' +
            '<button class="pcg-cmp-bgo" id="pcg-cmp-bgo" disabled>Comparer</button>' +
          '</div>' +
        '</div>' +
      '</div>' +

      /* Modal */
      '<div class="pcg-cmp-modal" id="pcg-cmp-modal" role="dialog" aria-modal="true" aria-label="Comparaison produits" hidden>' +
        '<div class="pcg-cmp-mbd" id="pcg-cmp-mbd"></div>' +
        '<div class="pcg-cmp-mp">' +
          '<div class="pcg-cmp-mh">' +
            '<h2 class="pcg-cmp-mtt">Comparaison</h2>' +
            '<button class="pcg-cmp-mc" id="pcg-cmp-mc" aria-label="Fermer">' +
              '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round">' +
                '<path d="M4 4l12 12M16 4L4 16"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="pcg-cmp-mb" id="pcg-cmp-mb"></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
  }

  function bindStatic() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest && (t.closest('#pcg-cmp-dcl') || t.closest('#pcg-cmp-bcl'))) { clearAll(); return; }
      if (t.closest && (t.closest('#pcg-cmp-go')  || t.closest('#pcg-cmp-bgo')))  { openModal(); return; }
      if (t.closest && (t.closest('#pcg-cmp-mc')  || t.id === 'pcg-cmp-mbd'))     { closeModal(); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  /* ── Utils ────────────────────────────────────────────────────────────── */

  function h(s) {
    if (s == null) return '';
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function strip(s) {
    var d = document.createElement('div');
    d.innerHTML = s;
    return d.textContent || d.innerText || s;
  }

  /* ── CSS ──────────────────────────────────────────────────────────────── */

  function injectStyles() {
    if (document.getElementById('pcg-cmp-css')) return;
    var s = document.createElement('style');
    s.id = 'pcg-cmp-css';
    s.textContent = [
      /* Compare toggle */
      '.pcg-cmp-toggle{display:flex;align-items:center;gap:7px;background:none;border:none;cursor:pointer;padding:0 0 8px;font-size:.8rem;font-family:inherit;color:inherit;text-align:left;user-select:none;opacity:.75;transition:opacity .15s;width:100%}',
      '.pcg-cmp-toggle:hover:not(:disabled){opacity:1}',
      '.pcg-cmp-toggle.is-on{opacity:1}',
      '.pcg-cmp-toggle.is-maxed{opacity:.35;cursor:not-allowed}',
      '.pcg-cmp-cb{width:16px;height:16px;flex-shrink:0;border:1.5px solid rgba(0,0,0,.3);border-radius:3px;display:flex;align-items:center;justify-content:center;background:#fff;transition:background .15s,border-color .15s}',
      '.pcg-cmp-toggle.is-on .pcg-cmp-cb{background:#111;border-color:#111}',
      '.pcg-cmp-ck{display:none}',
      '.pcg-cmp-toggle.is-on .pcg-cmp-ck{display:block}',

      /* Root container */
      '#pcg-cmp-root{position:fixed;z-index:500;inset:0;pointer-events:none}',

      /* Desktop drawer */
      '.pcg-cmp-drawer{position:fixed;right:0;top:50%;z-index:501;transform:translateY(-50%) translateX(calc(100% + 4px));transition:transform .32s cubic-bezier(.2,0,0,1);width:260px;background:#fff;color:#111;border-radius:12px 0 0 12px;box-shadow:-2px 0 28px rgba(0,0,0,.12);padding:18px;pointer-events:auto}',
      '.pcg-cmp-drawer.is-open{transform:translateY(-50%) translateX(0)}',
      '@media(max-width:749px){.pcg-cmp-drawer{display:none}}',
      '.pcg-cmp-dh{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px}',
      '.pcg-cmp-dt{font-size:.875rem;font-weight:700;letter-spacing:.02em}',
      '.pcg-cmp-dcl{font-size:.75rem;color:#999;background:none;border:none;cursor:pointer;text-decoration:underline;padding:0}',
      '.pcg-cmp-dcl:hover{color:#555}',
      '.pcg-cmp-dl{list-style:none;padding:0;margin:0 0 12px;display:flex;flex-direction:column;gap:10px;min-height:52px}',
      '.pcg-cmp-di{display:flex;align-items:center;gap:9px}',
      '.pcg-cmp-dth{width:46px;height:46px;border-radius:7px;overflow:hidden;flex-shrink:0;background:#f3f3f3;display:flex;align-items:center;justify-content:center}',
      '.pcg-cmp-dth img{width:100%;height:100%;object-fit:cover}',
      '.pcg-cmp-din{flex:1;min-width:0}',
      '.pcg-cmp-dn{font-size:.78rem;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:1.3}',
      '.pcg-cmp-dp{font-size:.73rem;color:#888;display:block;margin-top:2px}',
      '.pcg-cmp-dx{background:none;border:none;cursor:pointer;font-size:1.2rem;color:#bbb;line-height:1;padding:2px 4px;flex-shrink:0;transition:color .1s}',
      '.pcg-cmp-dx:hover{color:#333}',
      '.pcg-cmp-dmax{font-size:.7rem;color:#aaa;margin:0 0 10px;text-align:center}',
      '.pcg-cmp-go{width:100%;padding:12px;border-radius:9px;background:#111;color:#fff;border:none;cursor:pointer;font-size:.85rem;font-weight:600;transition:opacity .15s}',
      '.pcg-cmp-go:disabled{opacity:.35;cursor:default}',
      '.pcg-cmp-go:not(:disabled):hover{opacity:.8}',

      /* Mobile bar */
      '.pcg-cmp-bar{position:fixed;bottom:0;left:0;right:0;z-index:501;background:#fff;color:#111;box-shadow:0 -2px 18px rgba(0,0,0,.1);transform:translateY(100%);transition:transform .3s cubic-bezier(.2,0,0,1);padding:12px 16px;pointer-events:auto;display:none}',
      '.pcg-cmp-bar.is-open{transform:translateY(0)}',
      '@media(max-width:749px){.pcg-cmp-bar{display:block}}',
      '.pcg-cmp-bi{display:flex;align-items:center;justify-content:space-between;gap:12px}',
      '.pcg-cmp-bl{font-size:.85rem;font-weight:500}',
      '.pcg-cmp-ba{display:flex;align-items:center;gap:8px;flex-shrink:0}',
      '.pcg-cmp-bcl{background:none;border:none;cursor:pointer;font-size:.78rem;color:#999;text-decoration:underline;padding:0}',
      '.pcg-cmp-bgo{padding:10px 18px;border-radius:8px;background:#111;color:#fff;border:none;cursor:pointer;font-size:.85rem;font-weight:600;white-space:nowrap}',
      '.pcg-cmp-bgo:disabled{opacity:.35;cursor:default}',

      /* Modal overlay */
      '.pcg-cmp-modal{position:fixed;inset:0;z-index:10000;display:flex;flex-direction:column;align-items:stretch;justify-content:flex-end;pointer-events:auto}',
      '.pcg-cmp-modal[hidden]{display:none}',
      '.pcg-cmp-mbd{position:absolute;inset:0;background:rgba(0,0,0,.45);border:none;cursor:pointer;width:100%;height:100%}',
      '.pcg-cmp-mp{position:relative;background:#fff;color:#111;border-radius:16px 16px 0 0;max-height:88vh;display:flex;flex-direction:column;z-index:1}',
      '@media(min-width:750px){.pcg-cmp-modal{align-items:center;justify-content:center;padding:20px}.pcg-cmp-mp{border-radius:16px;width:min(94vw,1100px);max-height:86vh}}',
      '.pcg-cmp-mh{display:flex;align-items:center;justify-content:space-between;padding:16px 20px 14px;border-bottom:1px solid #eee;flex-shrink:0}',
      '.pcg-cmp-mtt{font-size:1rem;font-weight:700;margin:0}',
      '.pcg-cmp-mc{width:34px;height:34px;display:flex;align-items:center;justify-content:center;background:none;border:none;cursor:pointer;border-radius:50%;color:#555;transition:background .15s}',
      '.pcg-cmp-mc:hover{background:#f3f3f3}',
      '.pcg-cmp-mc svg{width:18px;height:18px}',
      '.pcg-cmp-mb{overflow:auto;flex:1;-webkit-overflow-scrolling:touch}',

      /* Comparison table */
      '.pcg-ct-wrap{min-width:max-content;padding:0 0 20px}',
      '.pcg-ct{border-collapse:collapse;width:100%}',
      '.pcg-ct-corner{width:150px;min-width:130px;padding:0}',
      '.pcg-ct-ph{min-width:190px;max-width:260px;padding:20px 16px 14px;vertical-align:top;text-align:center;border-left:1px solid #eee}',
      '.pcg-ct-pi{width:100%;max-width:150px;height:130px;object-fit:cover;border-radius:8px;display:block;margin:0 auto 10px}',
      '.pcg-ct-pi--empty{background:#f3f3f3;width:120px;height:120px;border-radius:8px;margin:0 auto 10px}',
      '.pcg-ct-pn{font-size:.875rem;font-weight:600;margin:0 0 4px;line-height:1.3}',
      '.pcg-ct-pp{font-size:.8rem;color:#888;margin:0 0 10px}',
      '.pcg-ct-pr{font-size:.73rem;color:#aaa;background:none;border:none;cursor:pointer;text-decoration:underline;padding:0;transition:color .1s}',
      '.pcg-ct-pr:hover{color:#333}',
      '.pcg-ct-lbl{padding:11px 16px 11px 20px;font-size:.78rem;font-weight:600;text-align:left;white-space:nowrap;vertical-align:middle;background:#fafafa;border-top:1px solid #eee;position:sticky;left:0;z-index:1}',
      '.pcg-ct-val{padding:11px 16px;font-size:.82rem;border-top:1px solid #eee;border-left:1px solid #eee;vertical-align:middle;text-align:center;white-space:pre-line}',
      '.pcg-ct-foot{padding:14px 16px;border-top:1px solid #eee;border-left:1px solid #eee;text-align:center}',
      '.pcg-ct-link{display:inline-block;padding:10px 18px;background:#111;color:#fff;border-radius:8px;font-size:.8rem;font-weight:600;text-decoration:none;transition:opacity .15s}',
      '.pcg-ct-link:hover{opacity:.75}',

      /* Sticky label column on scroll */
      '@media(min-width:750px){.pcg-ct-lbl{width:180px;min-width:160px}}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ── Start ────────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
